export default [{
  "name": "艺术哲学",
  "location": "A-3-01",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "[法]丹纳著，傅雷译"
}, {
  "name": "神形陌路──叶锦添的创意美学",
  "location": "A-3-02",
  "publisher": "三联书店（香港）有限公司",
  "count": 1,
  "author": "叶锦添"
}, {
  "name": "当代艺术的主题：1980年以后的视觉艺术（凤凰文库·艺术理论研究系列）",
  "location": "A-3-03",
  "publisher": "江苏美术",
  "count": 1,
  "author": "（美）罗伯森"
}, {
  "name": "这个世界会好吗",
  "location": "A-3-04",
  "publisher": "中国今日美术馆出版社有限公司",
  "count": 1,
  "author": "向京+广慈雕塑工作室"
}, {
  "name": "现代艺术1851-1929",
  "location": "A-3-05",
  "publisher": "上海人民出版社",
  "count": 1,
  "author": "[美]理查德·布雷特尔著，诸葛沂译"
}, {
  "name": "现代艺术150年：一个未完成的故事",
  "location": "A-3-06",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "[英]威尔·贡培兹著，王烁/王同乐译"
}, {
  "name": "艺术品读和定价",
  "location": "A-3-07",
  "publisher": "译林出版社",
  "count": 1,
  "author": "（荷兰）奥拉夫·维尔苏斯著，何国卿译"
}, {
  "name": "美的历程",
  "location": "A-3-08",
  "publisher": "人民文学出版社",
  "count": 1,
  "author": "李泽厚"
}, {
  "name": "美的历程",
  "location": "A-3-09",
  "publisher": "生活·读书·新知",
  "count": 1,
  "author": "李泽厚"
}, {
  "name": "墙：中国当代艺术的历史与边界",
  "location": "A-3-10",
  "publisher": "中国人民大学出版社",
  "count": 1,
  "author": "高名潞"
}, {
  "name": "世界名画赏析",
  "location": "A-3-11",
  "publisher": "河北教育出版社",
  "count": 3,
  "author": ""
}, {
  "name": "中国人本-纪实在当代",
  "location": "A-3-12",
  "publisher": "岭南美术出版社",
  "count": 1,
  "author": "王璜生"
}, {
  "name": "世界现代设计史（第二版）",
  "location": "A-3-13",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "王受之"
}, {
  "name": "世界平面设计史",
  "location": "A-3-14",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "王受之"
}, {
  "name": "感动，如此创造",
  "location": "A-3-15",
  "publisher": "中信出版社",
  "count": 1,
  "author": "[日本]久石让著，何启宏译"
}, {
  "name": "中国人的风雅",
  "location": "A-3-16",
  "publisher": "化学工业出版社",
  "count": 1,
  "author": "霁月著，巫娜奏，净如绘"
}, {
  "name": "电影的秘密：形式与意义",
  "location": "A-3-17",
  "publisher": "印刷工业",
  "count": 1,
  "author": "(美)斯蒂芬普林斯"
}, {
  "name": "镜头的语法(插图修订第2版)",
  "location": "A-3-18",
  "publisher": "北京联合",
  "count": 1,
  "author": "（英)罗伊·汤普森,(美)克里斯托弗·J·鲍恩"
}, {
  "name": "中国艺术通识名师精品课——美术专业论文写作",
  "location": "A-3-19",
  "publisher": "上海人民美术出版社",
  "count": 1,
  "author": "［美］苏珊娜•赫德森，南希•努南•莫里西著"
}, {
  "name": "中国当代私立美术馆独立调查访谈",
  "location": "A-3-20",
  "publisher": "上海玻璃博物馆",
  "count": 1,
  "author": "王上"
}, {
  "name": "比尔·维奥拉精选作品集1977-2014",
  "location": "A-3-21",
  "publisher": "河北教育出版社",
  "count": 1,
  "author": "红专厂当代艺术馆RMCA"
}, {
  "name": "布拉格praha",
  "location": "A-3-22",
  "publisher": "中国今日美术馆出版社",
  "count": 1,
  "author": "武艺"
}, {
  "name": "LiuXiaodong",
  "location": "A-3-23",
  "publisher": "Timezone8",
  "count": 1,
  "author": "AiWeiwei/PiLi/LiuXiaodong"
}, {
  "name": "日本浮世绘欣赏",
  "location": "A-3-24",
  "publisher": "河北教育出版社",
  "count": 6,
  "author": ""
}, {
  "name": "中国名画赏析",
  "location": "A-3-25",
  "publisher": "河北教育出版社",
  "count": 1,
  "author": "齐白石"
}, {
  "name": "人民的战士",
  "location": "A-3-26",
  "publisher": "連環畫出版社",
  "count": 10,
  "author": "石良"
}, {
  "name": "平板向度-从纸面到虚拟的视觉艺术",
  "location": "A-3-27",
  "publisher": "中国美术学院出版社",
  "count": 1,
  "author": "浙江美术馆编著"
}, {
  "name": "分子美学",
  "location": "A-3-28",
  "publisher": "北京师范大学未来设计学院",
  "count": 1,
  "author": "（德）彼得·韦伯（克罗地亚）丽丽亚娜·弗鲁克"
}, {
  "name": "重建巴别塔",
  "location": "A-3-29",
  "publisher": "北京时代华文书局",
  "count": 1,
  "author": "王端廷"
}, {
  "name": "身体.空间.时间：德勒兹艺术理论研究",
  "location": "A-3-30",
  "publisher": "中国社会科学出版社",
  "count": 1,
  "author": "张晨著"
}, {
  "name": "艺术学理论要略",
  "location": "A-3-31",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "王一川编"
}, {
  "name": "存在的艺术（弗洛姆作品系列）",
  "location": "A-3-32",
  "publisher": "上海译文",
  "count": 1,
  "author": "(美）艾里希弗洛姆"
}, {
  "name": "艺术哲学",
  "location": "A-3-33",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "［法］丹纳著傅雷译"
}, {
  "name": "艺术科学研究方法（精）",
  "location": "A-3-34",
  "publisher": "武汉理工",
  "count": 1,
  "author": "管顺丰|责编:刘凯〃胡璇小方"
}, {
  "name": "凤凰文库设计理论研究系列-恋物:情感、设计与物质文化",
  "location": "A-3-35",
  "publisher": "江苏美术",
  "count": 1,
  "author": "安娜莫兰"
}, {
  "name": "当代艺术经济学",
  "location": "A-3-36",
  "publisher": "东北财经大学出版社",
  "count": 1,
  "author": "阿莱西娅·左罗妮(AlessiaZorloni)"
}, {
  "name": "艺术与科学：从野生茄子到三宅一生",
  "location": "A-3-37",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "［法］卢瓦克•芒辻著，陈新华译"
}, {
  "name": "未来艺术势能七种",
  "location": "A-3-38",
  "publisher": "四川美术出版社",
  "count": 1,
  "author": "唐尧"
}, {
  "name": "画史之外",
  "location": "A-3-39",
  "publisher": "海燕出版社",
  "count": 1,
  "author": "郁俊"
}, {
  "name": "来日非善：艺术、批评、紧急事件",
  "location": "A-3-40",
  "publisher": "华中科技大学出版社",
  "count": 1,
  "author": " (美)哈尔·福斯特"
}, {
  "name": "全球视野下的当代艺术",
  "location": "A-3-41",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "邵亦杨"
}, {
  "name": "来日非善",
  "location": "A-3-42",
  "publisher": "重庆大学出版社",
  "count": 2,
  "author": " (美)哈尔·福斯特"
}, {
  "name": "现象",
  "location": "A-3-43",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "[日本]杉本博司"
}, {
  "name": "艺术战斗论-你也可以成为艺术家",
  "location": "A-3-44",
  "publisher": "时代文艺出版社",
  "count": 1,
  "author": "[日]村上隆著，长安静美译"
}, {
  "name": "艺术三万年：一部人类艺术创造力跨越时空的故事",
  "location": "A-3-45",
  "publisher": "四川美术出版社",
  "count": 1,
  "author": "［英］费顿出版社著，夏海宁译"
}, {
  "name": "女性制作艺术（历史主体审美）/艺术理论研究系列/凤凰文库",
  "location": "A-3-46",
  "publisher": "江苏美术",
  "count": 1,
  "author": "（英）玛莎•麦斯基蒙|总主编：范景中I译者:李苏杭"
}, {
  "name": "2018今日·艺术·研究",
  "location": "A-3-47",
  "publisher": "四川美术出版社",
  "count": 2,
  "author": "高鹏"
}, {
  "name": "包豪斯舞台",
  "location": "A-3-48",
  "publisher": "重庆大学出版社",
  "count": 2,
  "author": "(德)奥斯卡·施莱默(OskarSchlemmer)等"
}, {
  "name": "贡布里希文集全集11册",
  "location": "A-4-01",
  "publisher": "广西美术",
  "count": 1,
  "author": "贡布里希"
}, {
  "name": "策展的挑战",
  "location": "A-4-02",
  "publisher": "金城出版社",
  "count": 1,
  "author": "[法]侯瀚如/[瑞士]奥布里斯特,顾灵译"
}, {
  "name": "大学美术鉴赏(第2版普通高等学校公共艺术课程系列教材)",
  "location": "A-4-03",
  "publisher": "华东师范大学出版社",
  "count": 1,
  "author": "陈芳"
}, {
  "name": "当代视觉文化丛书：图像与阐释",
  "location": "A-4-04",
  "publisher": "湖南美术",
  "count": 1,
  "author": "布列逊"
}, {
  "name": "低垂之眼20世纪法国思想对视觉的贬损",
  "location": "A-4-05",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "［美］马丁,杰伊著"
}, {
  "name": "凤凰文库设计理论研究系列-公民设计师.论设计的责任",
  "location": "A-4-06",
  "publisher": "江苏美术",
  "count": 1,
  "author": "史蒂芬海勒"
}, {
  "name": "凤凰文库设计理论研究系列-批判性设计及其语境:历史、理论和实践",
  "location": "A-4-07",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(英)马特尔帕斯"
}, {
  "name": "凤凰文库设计理论研究系列-设计研究:方法与视角",
  "location": "A-4-08",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(美)布伦达:劳雷尔"
}, {
  "name": "凤凰文库设计理论研究系列-设计与历史的质疑",
  "location": "A-4-09",
  "publisher": "江苏美术",
  "count": 1,
  "author": "托尼:弗赖"
}, {
  "name": "凤凰文库设计理论研究系列-思辨一切.设计虚构与社会梦想",
  "location": "A-4-10",
  "publisher": "江苏美术",
  "count": 1,
  "author": "安东尼邓恩"
}, {
  "name": "凤凰文库设计理论研究系列-唯有粉红:审美品位的性别政治学",
  "location": "A-4-11",
  "publisher": "江苏美术",
  "count": 1,
  "author": "（英）彭妮斯帕克"
}, {
  "name": "观看的方法：如何解读视觉材料",
  "location": "A-4-12",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(英）吉莉恩罗斯"
}, {
  "name": "回视：历史想象与图像修辞",
  "location": "A-4-13",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(美)迈克尔安霍利"
}, {
  "name": "从设计到产业：刘小康的CMYK创意学",
  "location": "A-4-14",
  "publisher": "中国人民大学出版社",
  "count": 1,
  "author": "刘小康/谢傲霜"
}, {
  "name": "身体图景：艺术、现代性与理想形体",
  "location": "A-4-15",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(美)尼古拉斯·米尔佐夫"
}, {
  "name": "视觉文化面面观",
  "location": "A-4-16",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(加)玛格丽特·迪科维茨卡娅"
}, {
  "name": "视觉文化与视觉艺术符号学：艺术史研究的新视角",
  "location": "A-4-17",
  "publisher": "四川大学出版社",
  "count": 1,
  "author": "段炼著"
}, {
  "name": "视觉艺术的现象学",
  "location": "A-4-18",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "陝］保罗-克劳瑟"
}, {
  "name": "现代构成基础：色彩构成/高等院校艺术设计教育“十三五”规划教材",
  "location": "A-4-19",
  "publisher": "中南大学出版社",
  "count": 1,
  "author": "李鶴，彭雪云，李红松编"
}, {
  "name": "艺术设计专业论文写作——艺术设计名家特色精品课程",
  "location": "A-4-20",
  "publisher": "上海人民美术出版社",
  "count": 1,
  "author": "熊微著"
}, {
  "name": "应用色彩学",
  "location": "A-4-21",
  "publisher": "上海人美",
  "count": 1,
  "author": "傅炯,张惠山"
}, {
  "name": "三大构成基础造型系列教材（色彩+平面+立体+光迹套装共4册）",
  "location": "A-4-22",
  "publisher": "江苏凤凰科技",
  "count": 1,
  "author": "(日)朝仓直已"
}, {
  "name": "设计的125条通用法则",
  "location": "A-4-23",
  "publisher": "中国画报出版社",
  "count": 1,
  "author": "威廉-立德威尔.克里蒂娜.霍顿."
}, {
  "name": "设计管理",
  "location": "A-4-24",
  "publisher": "天津大学出版社",
  "count": 1,
  "author": "李通，赵莹雪著"
}, {
  "name": "凤凰文库设计理论研究系列-设计与价值创造",
  "location": "A-4-25",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(英)约翰.赫斯科特"
}, {
  "name": "图像学：形象、文本、意识形态",
  "location": "A-4-26",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "WIT.米歇尔著,陈永国译"
}, {
  "name": "凤凰文库设计理论研究系列-设计的政治:“全球”视觉传播导览",
  "location": "A-4-27",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(荷)鲁本-佩特"
}, {
  "name": "实用透视学/普通高等院校“十三五''规划教材•艺术教育系列",
  "location": "A-4-28",
  "publisher": "清华大学出版社",
  "count": 1,
  "author": "赵复雄，崔琳琳著"
}, {
  "name": "中国色彩简史",
  "location": "A-4-29",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "郭廉夫，郭渊著"
}, {
  "name": "凤凰文库设计理论研究系列-设计教育.教育设计",
  "location": "A-4-30",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(德)克劳斯.雷曼"
}, {
  "name": "凤凰文库设计理论研究系列-设计的观念.设计问题读本",
  "location": "A-4-31",
  "publisher": "江苏美术",
  "count": 1,
  "author": "维克多马格林"
}, {
  "name": "凤凰文库设计理论研究系列-约翰·赫斯科特读本:设计、历史、经济学",
  "location": "A-4-32",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(英）克莱夫迪诺特"
}, {
  "name": "艺术设计教育展望（上下）",
  "location": "A-4-33",
  "publisher": "西南师范大学出版社",
  "count": 1,
  "author": "陈汉民"
}, {
  "name": "艺术的真相：通往艺术之路",
  "location": "A-4-34",
  "publisher": "北京美术摄影出版社",
  "count": 1,
  "author": "张璞译"
}, {
  "name": "通过杜尚",
  "location": "A-4-35",
  "publisher": "中国人民大学出版社",
  "count": 1,
  "author": "王瑞芸"
}, {
  "name": "2007年首届今日文献展",
  "location": "A-4-36",
  "publisher": "中国今日美术馆出版社",
  "count": 1,
  "author": "张子康、黄笃"
}, {
  "name": "第三届今日文献展：另一种选择",
  "location": "A-4-37",
  "publisher": "江苏美术出版社",
  "count": 1,
  "author": "黄笃"
}, {
  "name": "包豪斯1919-1933（纪念包豪斯100周年巨献！世界知名艺术出版^±Taschen授权！重印20次！）",
  "location": "A-4-38",
  "publisher": "江苏凤凰科学技术出版社",
  "count": 1,
  "author": "［德］包豪斯档案馆著"
}, {
  "name": "加德纳艺术史经典版",
  "location": "A-4-39",
  "publisher": "湖南美术出版社",
  "count": 1,
  "author": "（美）弗雷德S克莱纳李建群等译书籍"
}, {
  "name": "加德纳艺术通史15版",
  "location": "A-5-01",
  "publisher": "湖南美术出版社",
  "count": 1,
  "author": "（美）弗雷德S克莱纳李建群等译"
}, {
  "name": "艺术的故事",
  "location": "A-5-02",
  "publisher": "广西美术出版社",
  "count": 3,
  "author": "贡布里希著，范景中译"
}, {
  "name": "艺术的起源",
  "location": "A-5-03",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "[日]杉本博司著，林叶译"
}, {
  "name": "改变艺术的100个观念",
  "location": "A-5-04",
  "publisher": "臉譜",
  "count": 1,
  "author": "麥可.柏德(MichaelBird)著，吳莉君译"
}, {
  "name": "视阈与绘画：凝视的逻辑",
  "location": "A-5-05",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(英)诺曼·布列逊"
}, {
  "name": "西方艺术学科史：古希腊到18世纪正版",
  "location": "A-5-06",
  "publisher": "文化艺术出版社",
  "count": 1,
  "author": "孙晓霞"
}, {
  "name": "艺术史导论艺术史学习经典指南",
  "location": "A-5-07",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "(德)汉斯·贝尔廷等"
}, {
  "name": "20世纪视觉艺术",
  "location": "A-5-08",
  "publisher": "中国人民大学出版社",
  "count": 1,
  "author": "爱德华·路希·史密斯著，彭萍译"
}, {
  "name": "现代艺术史插图第六版",
  "location": "A-5-09",
  "publisher": "湖南美术出版社",
  "count": 1,
  "author": "［美］H.,H•’阿纳森，［H.,H.…著，钱志坚译"
}, {
  "name": "新艺术的震撼",
  "location": "A-5-10",
  "publisher": "中国美术学院出版社",
  "count": 2,
  "author": "[澳]罗伯特·休斯"
}, {
  "name": "现代艺术源流年表：立体主义与未来主义",
  "location": "A-5-11",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "赵冠男著"
}, {
  "name": "西方艺术通史（原书第4版）艺术史导论雕塑、绘画、建筑、摄影等艺术艺术爱好者书目全景视角",
  "location": "A-5-12",
  "publisher": "机械工业出版社",
  "count": 1,
  "author": "（美）劳里;施耐德;亚当斯（Laurie Schneider Adams）"
}, {
  "name": "2010第二届今日文献展:调节器",
  "location": "A-5-13",
  "publisher": "文化艺术出版社",
  "count": 1,
  "author": ""
}, {
  "name": "名利场",
  "location": "A-5-14",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "戈弗雷·巴克著，马维达译"
}, {
  "name": "大话中国艺术史",
  "location": "A-5-15",
  "publisher": "海南出版社",
  "count": 1,
  "author": "意公子"
}, {
  "name": "一看就懂的中国艺术史：书画卷一",
  "location": "A-5-16",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "祝唯庸"
}, {
  "name": "一看就懂的中国艺术史：书画卷二",
  "location": "A-5-17",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "祝唯庸"
}, {
  "name": "一看就懂的中国艺术史：书画卷三",
  "location": "A-5-18",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "祝唯庸"
}, {
  "name": "中国当代设计全集(第1卷)",
  "location": "A-5-19",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第2卷)",
  "location": "A-5-20",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第3卷)",
  "location": "A-5-21",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第4卷)",
  "location": "A-5-22",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第5卷)",
  "location": "A-5-23",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第6卷)",
  "location": "A-5-24",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第7卷)",
  "location": "A-5-25",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第8卷)",
  "location": "A-5-26",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第9卷)",
  "location": "A-5-27",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第10卷)",
  "location": "A-6-01",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第11卷)",
  "location": "A-6-02",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第12卷)",
  "location": "A-6-03",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第13卷)",
  "location": "A-6-04",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第14卷)",
  "location": "A-6-05",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第15卷)",
  "location": "A-6-06",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第16卷)",
  "location": "A-6-07",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第17卷)",
  "location": "A-6-08",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第18卷)",
  "location": "A-6-09",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第19卷)",
  "location": "A-6-10",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "中国当代设计全集(第20卷)",
  "location": "A-6-11",
  "publisher": "商务印书馆",
  "count": 1,
  "author": "王琥等编"
}, {
  "name": "山海新经",
  "location": "A-6-12",
  "publisher": "浙江人民美术出版社",
  "count": 1,
  "author": "浙江美术馆"
}, {
  "name": "张光宇集西游漫记",
  "location": "A-6-13",
  "publisher": "人民美术出版社",
  "count": 1,
  "author": "张光宇"
}, {
  "name": "10000年中国艺术史（上册）",
  "location": "A-6-14",
  "publisher": "江苏凤凰文艺出版社",
  "count": 1,
  "author": "王逊著"
}, {
  "name": "10000年中国艺术史（下册）",
  "location": "A-6-15",
  "publisher": "江苏凤凰文艺出版社",
  "count": 1,
  "author": "王逊著"
}, {
  "name": "中国艺术史",
  "location": "A-6-16",
  "publisher": "上海人民出版社",
  "count": 1,
  "author": "迈克尔·苏立文著，徐坚译"
}, {
  "name": "1979年以来的中国艺术史",
  "location": "A-6-17",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "易丹,吕澎"
}, {
  "name": "中国美术简史",
  "location": "A-6-18",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "中央美术学院美术史系中国美术史教研室"
}, {
  "name": "艺术、权力与消费：中国艺术史研究的一个面向",
  "location": "A-6-19",
  "publisher": "中国美术学院",
  "count": 1,
  "author": "王正华"
}, {
  "name": "中国现代美术之路图鉴",
  "location": "A-6-20",
  "publisher": "高等教育出版社",
  "count": 1,
  "author": "潘公凯"
}, {
  "name": "中国当代艺术史[HistoryofChineseContemporaryArt]",
  "location": "A-6-21",
  "publisher": "上海大学出版社",
  "count": 1,
  "author": "高名潞著"
}, {
  "name": "中国当代艺术简史",
  "location": "A-6-22",
  "publisher": "上海书画出版社",
  "count": 1,
  "author": "吕澎"
}, {
  "name": "绘画的精神：蔡国强在普拉多",
  "location": "A-6-23",
  "publisher": "湖南美术出版社",
  "count": 1,
  "author": "蔡国强"
}, {
  "name": "中国民营美术馆运营及筹建研究",
  "location": "A-6-24",
  "publisher": "四川美术出版社",
  "count": 3,
  "author": "高鹏"
}, {
  "name": "坂本龙一：观音·听时",
  "location": "A-6-25",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "北京木木美术馆"
}, {
  "name": "现代艺术与设计的兴起：迷人的20世纪维也纳",
  "location": "A-6-26",
  "publisher": "华中科技大学出版社",
  "count": 1,
  "author": "［奥］克里斯、布兰兹塔特，〔奥］达尼埃拉•格雷戈里’［德］雷内•梅斯热著"
}, {
  "name": "历史之路：威尼斯双年展与中国当代艺术20年",
  "location": "A-6-27",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "-"
}, {
  "name": "伟大的博物馆（1-16卷）",
  "location": "B-3-01",
  "publisher": "译林出版社",
  "count": 1,
  "author": ""
}, {
  "name": "伟大的博物馆（17-31卷）",
  "location": "B-3-02",
  "publisher": "译林出版社",
  "count": 1,
  "author": ""
}, {
  "name": "路易丝•布尔乔亚：永恒的丝线",
  "location": "B-3-03",
  "publisher": "清华大学出版社",
  "count": 1,
  "author": "路易丝•布尔乔亚著，松美术馆译"
}, {
  "name": "写给孩子的美育通识课全10册",
  "location": "B-3-04",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "郑勤砚主编;霍晨昕编著"
}, {
  "name": "世界的壳·作家与徐累",
  "location": "B-3-05",
  "publisher": "文化艺术出版社",
  "count": 1,
  "author": "朱朱/邹静之/苏童/陈丹青/张悦然"
}, {
  "name": "名画之谜：51幅世界杰作的秘密",
  "location": "B-3-06",
  "publisher": "华中科技大学出版社",
  "count": 1,
  "author": "［法］格拉德•迪尼佐著"
}, {
  "name": "蒙德里安论新造型",
  "location": "B-3-07",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "蒋煜恒著"
}, {
  "name": "蒙德里安论新造型",
  "location": "B-3-08",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "蒋煜恒著"
}, {
  "name": "绘画透视学（新版）",
  "location": "B-3-09",
  "publisher": "上海人民美术出版社",
  "count": 1,
  "author": "张忆周著"
}, {
  "name": "BBC艺术经典三部曲",
  "location": "B-3-10",
  "publisher": "中国美术学院出版社",
  "count": 1,
  "author": "西蒙玛莎、罗伯特休斯、肯尼斯克拉克"
}, {
  "name": "景观社会的图像",
  "location": "B-3-11",
  "publisher": "清华大学出版社",
  "count": 1,
  "author": "范晓楠"
}, {
  "name": "故宫珍藏书画精粹",
  "location": "B-3-12",
  "publisher": "北京出版社",
  "count": 1,
  "author": "吉平"
}, {
  "name": "雅债·文徽明的社交性艺术",
  "location": "B-3-13",
  "publisher": "生活·读书·新知三联书店",
  "count": 1,
  "author": "柯律格著，刘宇珍、邱士华、胡隽译"
}, {
  "name": "刘晓东在和田&新疆新观察",
  "location": "B-3-14",
  "publisher": "中信出版社",
  "count": 1,
  "author": "刘小东/侯瀚如/阿城/杨波/欧宁/黄振伟"
}, {
  "name": "徐累画集",
  "location": "B-3-15",
  "publisher": "文化艺术出版社",
  "count": 1,
  "author": "徐累"
}, {
  "name": "今日艺术家",
  "location": "B-3-16",
  "publisher": "河北美术出版社",
  "count": 1,
  "author": "方力钧"
}, {
  "name": "春天来了",
  "location": "B-3-17",
  "publisher": "湖南美术出版社",
  "count": 1,
  "author": "袁庆一"
}, {
  "name": "徐冰版画",
  "location": "B-3-18",
  "publisher": "文化艺术出版社",
  "count": 1,
  "author": "徐冰"
}, {
  "name": "绘画本中国通史（共6卷）",
  "location": "B-3-19",
  "publisher": "浙江少年儿童出版社",
  "count": 6,
  "author": "龚延明(主编)"
}, {
  "name": "雍和宫唐喀瑰宝",
  "location": "B-3-20",
  "publisher": "北京出版社",
  "count": 1,
  "author": "汤博文"
}, {
  "name": "世界名画欣赏·第三辑（梵高）",
  "location": "B-3-21",
  "publisher": "河北教育出版社",
  "count": 1,
  "author": "徐占博等编"
}, {
  "name": "河童旅行素描本",
  "location": "B-3-22",
  "publisher": "生活·读书·新知三联书店",
  "count": 1,
  "author": "[日]妹尾河童著，姜淑玲译"
}, {
  "name": "thelittlestardweller",
  "location": "B-3-23",
  "publisher": "北方妇女儿童出版社",
  "count": 1,
  "author": "奈良美智著，黄碧君、王筱玲译"
}, {
  "name": "蜘蛛侠觉醒篇",
  "location": "B-3-24",
  "publisher": "译林出版社",
  "count": 1,
  "author": "[美]比尔·吉马斯/[美]布赖恩·迈克尔·本迪斯著，郭启新译"
}, {
  "name": "美术馆",
  "location": "B-3-25",
  "publisher": "中国青年出版社",
  "count": 1,
  "author": "张子康/罗怡"
}, {
  "name": "集王羲之书圣教序",
  "location": "B-3-26",
  "publisher": "中国和平出版社",
  "count": 1,
  "author": ""
}, {
  "name": "汉字的诱惑",
  "location": "B-3-27",
  "publisher": "湖北美术出版社",
  "count": 1,
  "author": "陈楠"
}, {
  "name": "中国现代文字设计图史",
  "location": "B-3-28",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "周博"
}, {
  "name": "王羲之书法集上下卷",
  "location": "B-3-29",
  "publisher": "北京工艺美术出版社",
  "count": 1,
  "author": "王羲之"
}, {
  "name": "历代名家书心经",
  "location": "B-3-30",
  "publisher": "中信出版社",
  "count": 1,
  "author": "金墨"
}, {
  "name": "美术教育研究方法与论文写作",
  "location": "B-3-31",
  "publisher": "西南师范大学出版社",
  "count": 1,
  "author": "李力加，钟朝芳著"
}, {
  "name": "表征的重负：论摄影与历史",
  "location": "B-3-32",
  "publisher": "重庆大学出版社",
  "count": 1,
  "author": "(美)约翰塔格"
}, {
  "name": "RefractedModernity",
  "location": "B-3-33",
  "publisher": "UniversityofHawaiiPress",
  "count": 1,
  "author": "YukoKikuchi"
}, {
  "name": "今日肖全",
  "location": "B-3-34",
  "publisher": "江苏凤凰美术出版社",
  "count": 2,
  "author": "肖全"
}, {
  "name": "EadweardMuybridge",
  "location": "B-3-35",
  "publisher": "TASCHEN",
  "count": 1,
  "author": "EadwardMuybridge"
}, {
  "name": "TheOlympicImage",
  "location": "B-3-36",
  "publisher": "Booth-ClibbornEditions",
  "count": 1,
  "author": ""
}, {
  "name": "凤凰文库设计理论研究系列：设计史与设计的历史",
  "location": "B-4-01",
  "publisher": "江苏美术",
  "count": 1,
  "author": "约翰A.沃克"
}, {
  "name": "美国视觉设计学院用书：完成设计——从理论到实践",
  "location": "B-4-02",
  "publisher": "广西美术出版社",
  "count": 1,
  "author": " (美)萨马拉"
}, {
  "name": "服务设计与创新",
  "location": "B-4-03",
  "publisher": "中国建筑工业出版社",
  "count": 1,
  "author": "王国胜"
}, {
  "name": "DesignDialogues",
  "location": "B-4-04",
  "publisher": "StMartinsPr",
  "count": 1,
  "author": "Heller,Steven(EDT)/Pettit,Elinor/Heller,Steven/Pettit,Elinor(EDT)"
}, {
  "name": "100个改变时尚的伟大观念",
  "location": "B-4-05",
  "publisher": "中国摄影出版传媒有限责任公司",
  "count": 1,
  "author": "［英］哈里特，沃斯里著，唐万\\佳译"
}, {
  "name": "凤凰文库设计理论研究系列-设计史.理解理论与方法",
  "location": "B-4-06",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(挪)谢尔提法兰"
}, {
  "name": "凤凰文库设计理论研究系列-世界设计史1",
  "location": "B-4-07",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(美)维克多马格林"
}, {
  "name": "凤凰文库设计理论研究系列-世界设计史2",
  "location": "B-4-08",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(美)维克多马格林"
}, {
  "name": "现代设计史（第2版）",
  "location": "B-4-09",
  "publisher": "中国人大",
  "count": 1,
  "author": "(美)瑞兹曼"
}, {
  "name": "阿明•霍夫曼的设计原则",
  "location": "B-4-10",
  "publisher": "上海人民美术出版社",
  "count": 1,
  "author": "阿明•霍夫曼，杜钦、刘育黎译"
}, {
  "name": "凤凰文库设计理论研究系列-平面设计理论:来自田野的读本",
  "location": "B-4-11",
  "publisher": "江苏美术",
  "count": 1,
  "author": "(美）海伦阿姆斯特朗"
}, {
  "name": "地书",
  "location": "B-4-12",
  "publisher": "广西师范大学出版社",
  "count": 1,
  "author": "徐冰"
}, {
  "name": "中国纹样全集:新石器时代和商.西周.春秋卷",
  "location": "B-4-13",
  "publisher": "山东美术",
  "count": 1,
  "author": "吴山"
}, {
  "name": "美国视觉设计学院从书：设计元素.平面设计样式",
  "location": "B-4-14",
  "publisher": "广西美术出版社",
  "count": 1,
  "author": " (美)萨马拉"
}, {
  "name": "森林消费*再生品牌",
  "location": "B-4-15",
  "publisher": "三联书店（香港）",
  "count": 1,
  "author": "张帝庄"
}, {
  "name": "转媒体艺术：新媒体展览展示设计",
  "location": "B-4-16",
  "publisher": "上海大学出版社",
  "count": 1,
  "author": "杨青青，［德］飞苹果著"
}, {
  "name": "世界花纹与图案大典(精)",
  "location": "B-4-17",
  "publisher": "河南美术出版社",
  "count": 1,
  "author": "(英)伊丽莎白:威尔海德"
}, {
  "name": "音乐的历史",
  "location": "B-4-18",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)房龙"
}, {
  "name": "尖叫的经典：冰岛音乐简史",
  "location": "B-4-19",
  "publisher": "中信",
  "count": 1,
  "author": "张长晓"
}, {
  "name": "音效圣经好莱坞音效创作及录制技巧(插图修订版)",
  "location": "B-4-20",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)维尔斯"
}, {
  "name": "诗意的身体",
  "location": "B-4-21",
  "publisher": "四川文艺",
  "count": 1,
  "author": "(法)雅克勒考克"
}, {
  "name": "这就是戏剧",
  "location": "B-4-22",
  "publisher": "北京大学出版社",
  "count": 1,
  "author": "［美］罗伯特•科恩著，费春放，梁超群译"
}, {
  "name": "导演思维（修订版）",
  "location": "B-4-23",
  "publisher": "印刷工业",
  "count": 1,
  "author": "(美）肯丹西格"
}, {
  "name": "如何做导演：从观念到技术",
  "location": "B-4-24",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)威廉·保尔"
}, {
  "name": "表演练声课：释放天然嗓音（增订版）",
  "location": "B-4-25",
  "publisher": "印刷工业",
  "count": 1,
  "author": "（英）克里斯廷·林克莱特"
}, {
  "name": "激昂的幻梦从斯坦尼体系到方法派表演",
  "location": "B-4-26",
  "publisher": "台海出版",
  "count": 1,
  "author": "(美）李斯特拉斯伯格"
}, {
  "name": "心灵的杂技：形体训练表演课",
  "location": "B-4-27",
  "publisher": "四川人民",
  "count": 1,
  "author": "美)斯蒂芬·旺"
}, {
  "name": "演员的力量：查伯克十二步骤表演法\n",
  "location": "B-4-28",
  "publisher": "印刷工业",
  "count": 1,
  "author": "(美)伊万娜·查伯克"
}, {
  "name": "演员怎样进入角色：吉斯特表演法",
  "location": "B-4-29",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)乔·阿尔伯蒂,(美)厄尔·R·吉斯特"
}, {
  "name": "英国皇家戏剧学院表演训练法",
  "location": "B-4-30",
  "publisher": "印刷工业",
  "count": 1,
  "author": "(日)三轮绘理花"
}, {
  "name": "致演员",
  "location": "B-4-31",
  "publisher": "中国友谊",
  "count": 1,
  "author": "(苏)迈克尔·契诃夫"
}, {
  "name": "尊重表演艺术",
  "location": "B-4-32",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)哈根,(美)弗兰克尔"
}, {
  "name": "如何成为地球上最棒的即兴演员",
  "location": "B-4-33",
  "publisher": "九州",
  "count": 1,
  "author": "(美)威尔·海因斯"
}, {
  "name": "演技教程表演心理学（最新修订版）",
  "location": "B-4-34",
  "publisher": "北京联合 ",
  "count": 1,
  "author": "北京联合出版公司"
}, {
  "name": "表演的技术：迈克尔?契诃夫表演训练法",
  "location": "B-4-35",
  "publisher": "四川人民",
  "count": 1,
  "author": "(美)迈克尔契诃夫"
}, {
  "name": "表演的艺术",
  "location": "B-4-36",
  "publisher": "北京联合",
  "count": 1,
  "author": "(美)阿德勒"
}, {
  "name": "即兴",
  "location": "B-4-37",
  "publisher": "贵州人民",
  "count": 1,
  "author": "(英)基思约翰斯通"
}, {
  "name": "石挥谈艺录海阔天空",
  "location": "B-4-38",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "石挥"
}, {
  "name": "演技六讲：创造角色的灵魂（增订纪念版）",
  "location": "B-4-39",
  "publisher": "四川人民",
  "count": 1,
  "author": "（美）理查德·波列斯拉夫斯基"
}, {
  "name": "认识电影（全彩插图第12版）",
  "location": "B-4-40",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "(美)贾内梯"
}, {
  "name": "电影概论（第2版）",
  "location": "B-4-41",
  "publisher": "北京联合\r",
  "count": 1,
  "author": "杨远婴"
}];



// WEBPACK FOOTER //
// ./src/data/index.js